import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BubbleOptions } from '../../../utils/models/bubble-options';
import { customColorSets } from '../../../utils/custom-color-sets';

@Component({
    selector: 'neu-charts-bubble',
    template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-bubble-chart
        [view]="options.view"
        [scheme]="colorScheme"
        [results]="data"
        [legend]="options.showLegend"
        [xAxis]="options.showXAxis"
        [yAxis]="options.showYAxis"
        [showXAxisLabel]="options.showXAxisLabel"
        [showYAxisLabel]="options.showYAxisLabel"
        [xAxisLabel]="options.xAxisLabel"
        [yAxisLabel]="options.yAxisLabel"
        [autoScale]="options.autoScale"
        
        [roundDomains]="options.roundDomains"
        [minRadius]="options.minRadius"
        [maxRadius]="options.maxRadius"
        (select)="mSelectedEvent($event)">
    </ngx-charts-bubble-chart>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
    styles: [``]
})
export class BubbleComponent implements OnInit {

    @Input('data') data: any[] = [];
    @Input('options') customOptions: BubbleOptions;

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    options: BubbleOptions = new BubbleOptions();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() {
        Object.assign(this.options, this.customOptions);

        console.log("bub option", this.options);
    }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
